import styled from 'styled-components';

export const Container = styled.div`
  .modal-change-state-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .modal-change-state-message {
      width: 100%;
      max-width: 36rem;
      padding: 1rem 2rem;
      background-color: var(--blue_light_light);
      border-radius: 0.6rem;
      text-align: center;
      color: var(--primary_color);
      font-size: 0.9rem;
      font-weight: 700;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 2rem;
      margin-top: 3rem;
    }

    .modal-button {
      align-self: center;
      font-style: normal;
      text-transform: none;
    }

    .simple-select {
      min-width: 15rem;

      .css-2b097c-container
        .react-select__control
        .react-select__value-container
        .css-1uccc91-singleValue {
        color: #a5a5a5;
      }
    }
  }
`;
